<section class="degree">
  <div class="container heading">
    <h1>1 year</h1>

  </div>

  <div class="container-fluid subjects">
    <ng-container *ngIf="loader>0">
      <div class="container">
        <h2 class="heading">Subjects</h2>
      </div>
      <div class="slider">
        <div class="container">
          <div class="row">
            <div *ngFor="let subject of assigs" class="subject col-6 col-md-3">
              <app-SubjectSlideInfo [subject]="subject">
              </app-SubjectSlideInfo>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="loader==0">
      <div class="container">
        <h2 class="heading">Subjects</h2>
        <div class="loader text-center">
          <i class="fa-4x fa fa-spinner fa-pulse"></i>
          <h4>Loading subjects...</h4>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="container-fluid teachers">
    <div class="slider" *ngIf="teachers">
      <div class="container">
        <h2>Teachers</h2>
      </div>
      <ng-container *ngIf="loader>0">
        <div class="container">
          <div class="row carousel" *ngIf="loader>0">
            <div *ngFor="let teacher of teachers;let i = index" class="col-6 col-md-3 col-xl-3 teach">
              <app-teacherSlideInfo [profe]="teacher">
              </app-teacherSlideInfo>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="loader==0">
        <div class="container">
          <div class="loader text-center">
            <i class="fa-4x fa fa-spinner fa-pulse"></i>
            <h4>Loading subjects...</h4>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>